import { Pipe, PipeTransform } from '@angular/core';
import { StringUtils } from '@shared/utils/string.utils';

@Pipe({
  name: 'textCase'
})
export class TextCasePipe implements PipeTransform {

  transform(value: any, ...args: any[]) {
    if (typeof value !== 'string') {
      return value;
    }
    return StringUtils.textCase(value);
  }

}
